<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :submit="handleSubmitFormEditInvoice"
        :width="sizeSlideOver"
        :undo-enable="true"
        @close="handleClose"
        @undo="undo">
        <hts-card :title="$t('labels.editInvoicingInformation')">
            <div
                class="grid gap-5"
                :class="columnClass">
                <hts-form-input
                    :placeholder="companyName"
                    :label="$t('labels.companyName')"
                    :color="props.color"
                    :disabled="true"
                    name="company"
                    prop="company" />
                <hts-form-input
                    v-model="dataFormInvoice.name"
                    :label="$t('labels.name')"
                    :required="true"
                    :color="props.color"
                    name="name"
                    prop="name" />
                <hts-form-input
                    v-model="dataFormInvoice.address"
                    :label="$t('labels.address')"
                    :color="props.color"
                    name="address"
                    prop="address" />
                <hts-form-input
                    v-model="dataFormInvoice.accountNumber"
                    :label="$t('labels.accountNumber')"
                    :color="props.color"
                    name="accountNumber"
                    prop="accountNumber" />
                <hts-form-input
                    v-model="dataFormInvoice.accountName"
                    :label="$t('labels.accountName')"
                    :color="props.color"
                    name="accountName"
                    prop="accountName" />
                <hts-form-input
                    v-model="dataFormInvoice.swiftCode"
                    :label="$t('labels.swiftCode')"
                    :color="props.color"
                    name="swiftCode"
                    prop="swiftCode" />
                <hts-form-input
                    v-model="dataFormInvoice.taxNumber"
                    :label="$t('labels.taxNumber')"
                    :color="props.color"
                    name="taxNumber"
                    prop="taxNumber" />
                <hts-form-input
                    v-model="dataFormInvoice.phone"
                    :label="$t('labels.phone')"
                    :color="props.color"
                    name="phone"
                    prop="phone" />
            </div>
        </hts-card>
    </hts-slide-over>
</template>

<script setup lang="ts">
import invoicingData from './imports/invoice-form'

const store = $store()
const companyName = ref('')
const dataFormInvoice = reactive({ ...invoicingData.initInvoice })
onMounted(() => {
  companyName.value = store.system.company.name
})
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  invoiceIsSelectedToEdit: {
    type: Object,
    default: () => {}
  }
})
const emits = defineEmits(['close', 'refresh', 'undo'])
const handleClose = () => {
  emits('close')
}
watch(props, () => {
  _init()
})
const _init = () => {
  Object.assign(dataFormInvoice, props.invoiceIsSelectedToEdit)
}
const undo = () => {
  _init()
}

const handleSubmitFormEditInvoice = () => {
  const api = $url.company.updateInvoice
  $api(api, { body: new URLSearchParams(dataFormInvoice) })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (!responseData) {
        return true
      }
      if (responseData.success) {
        Object.assign(dataFormInvoice, { ...data })
        emits('refresh')
        process.client && $toast().success($t('labels.editSuccess'))
        emits('close')
        undo()
      }
    })
    .catch((error: any) => error)
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-5'
})
</script>
